// 404.js
import React from "react";

const NotFound = () => {
  return (
    <div style={{ textAlign: "center", marginTop: "150px" }}>
      <h1>404 - Page Not Found</h1>
      <p>Oops! The page you are looking for does not exist.</p>
      <a href="/">Go to Home</a>
    </div>
  );
};

export default NotFound;
